<script>
const script = document.createElement('script')
let cb

script.async = true
script.src = 'https://www.google.com/recaptcha/api.js?render=' + process.env.VUE_APP_RECAPTCHA_KEY + '&onload=onReCaptchaLoad'

window.onReCaptchaLoad = _ => {
    window.grecaptcha.ready(function () {
        cb(window.grecaptcha)
    })
}

export default {
    data() {
        return {
            ready: false,

            // Для того, чтобы обновлять капчу по таймеру, надо запомнить, какие настройки ей передевались в последнем вызове
            latestExecutedOpts: null,
            timer: null
        }
    },

    destroyed() {
        location.reload()
    },

    beforeMount() {
        cb = this.loaded

        this.ready = !!window.grecaptcha

        if (!this.ready || !script.parentNode) {
            document.head.append(script)
        }
    },

    // LITE-80, Капча живет две минуты. Ее надо обновлять, чтобы не протухла.
    // https://stackoverflow.com/a/63937913
    created() {
        this.timer = setInterval(this.refresh, 90 * 1000)
    },

    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },

    methods: {
        loaded() {
            this.ready = true
            this.$emit('ready')
        },

        async refresh() {
            if (!this.latestExecutedOpts) {
                return
            }

            return this.execute(this.latestExecutedOpts)
        },

        async execute(opts) {
            if (!this.ready) {
                return
            }

            try {
                const token = await window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY, opts || {})
                this.$emit('input', token)

                this.latestExecutedOpts = { ...opts }
            } catch (e) {
                console.log(e)
            }
        }
    },

    render(h) {
        return h('div')
    }
}
</script>
